module.exports = __webpack_public_path__ + "img/pc_banner_sup_faq_k.c79dce2b.webp";